import dayjs from "dayjs";

export const generateRandomString = () => {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"; // Character set
  const numbers = "0123456789"; // Number set

  // Generate 3 random letters
  let randomChars = "";
  for (let i = 0; i < 3; i++) {
    randomChars += letters.charAt(Math.floor(Math.random() * letters.length));
  }

  // Generate 6 random numbers
  let randomNumbers = "";
  for (let i = 0; i < 6; i++) {
    randomNumbers += numbers.charAt(Math.floor(Math.random() * numbers.length));
  }

  return randomChars + randomNumbers;
};

export const formatDate = (timestamp) => {
  const date = new Date(timestamp);

  // Get the components of the date
  const options = { year: "numeric", month: "short", day: "numeric" };
  const formattedDate = date.toLocaleDateString("en-US", options);

  // Get the time in 12-hour format with AM/PM
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const period = hours >= 12 ? "PM" : "AM";
  const formattedTime = `${hours % 12 || 12}:${minutes}:${seconds} ${period}`;

  // Return the full formatted string
  return `${formattedDate} | ${formattedTime}`;
};

export const createArray = (number) => {
  return Array.from({ length: number }, (_, index) => index + 1);
};

// Function to get the day with the correct suffix
export function getDayWithSuffix(day) {
  const j = day % 10,
    k = day % 100;
  if (j === 1 && k !== 11) {
    return day + "st";
  }
  if (j === 2 && k !== 12) {
    return day + "nd";
  }
  if (j === 3 && k !== 13) {
    return day + "rd";
  }
  return day + "th";
}

export const daysOfWeek = [
  { label: "Monday", value: "Mon" },
  { label: "Tuesday", value: "Tue" },
  { label: "Wednesday", value: "Wed" },
  { label: "Thursday", value: "Thu" },
  { label: "Friday", value: "Fri" },
  { label: "Saturday", value: "Sat" },
  { label: "Sunday", value: "Sun" },
];

// Function to convert and format date with day suffix
export function formatDateWithSuffix(dateStr) {
  const formattedDate = dayjs(dateStr).format("MMMM D, YYYY");
  // Add the suffix to the day
  return formattedDate.replace(/(\d+)/, (match) => getDayWithSuffix(match));
}
